<template>
  <div class="temporizador">
    <h1 style="text-align: center">Temporizador</h1>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>